import _ from 'lodash'
import {organizationPermissionCodes, permissionCodes,} from 'modules/permissions/contants'
import PermissionContext from 'modules/permissions/PermissionContext'
import React, {useContext} from 'react'
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import {branch, compose, nest} from 'recompose'
import {getLogin} from 'redux/selectors'
import {staticPaths} from 'routes/staticPaths'
import {createCheckPermissions, hasPermissions,} from 'views/AppLocals/factory/createCheckPermissions'
import {ModuleLayoutWrapper} from 'views/AppLocals/factory/createModule'
import DefaultTemplate from 'views/AppLocals/Templates/DefaultTemplate'
import {NullAsDefault} from 'views/Shared'
import WorkspaceActivities from './Activities/WorkspaceActivities'
import WorkspaceBanner from './components/WorkspaceBanner'
import WorkspaceFeatures from './components/WorkspaceFeatures'
import WorkspaceExamination from './Examination/WorkspaceExamination'
import WorkspaceHome from './HomePage/WorkspaceHome'
import WorkspaceHosts from './Host/WorkspaceHosts'
import WorkspaceOperating from './Operating/WorkspaceOperating'
import WorkspaceSetting from './Settings/WorkspaceSetting'
import WorkspaceContext, {WorkspaceProvider} from './WorkspaceContext'
import WorkspaceLandingPage from './WorkspaceLandingPage'
import WorkspaceMembers from "./Host/WorkspaceMembers";
import WorkspaceCourse from "./Course/WorkspaceCourse";
import WorkspaceCatholicHousehold from "./CatholicHousehold/WorkspaceCatholicHousehold";
import LoadingBlock from "../LoadingBlock";
import WorkspaceShop from "./Shop/WorkspaceShop";
import {validateServiceType} from "../Organization/functions/validateServiceType";

export const WorkSpaceActions = Object.freeze({
    HOME: 'dashboard',
    ACTIVITIES: 'activities',
    EVENT: 'event',
    SETTING: 'setting',
    SALES: 'sales',
    OPERATING: 'operating',
    STRUCTURES: 'structures',
    MEMBER: 'member',
    EXAMINATION: 'examination',
    COURSE: 'course',
    SHOP: 'shop',
    COURSE_DEPRECATED: 'course-deprecated',
    HOUSEHOLD: 'households',
    MUSIC: 'music',
})

const routes = [
    {
        key: WorkSpaceActions.HOME,
        label: 'overview',
        component: WorkspaceHome,
        isOptional: false
    },
    {
        key: WorkSpaceActions.ACTIVITIES,
        label: 'activities',
        component: WorkspaceActivities,
        isOptional: false,
    },
    {
        key: WorkSpaceActions.STRUCTURES,
        label: 'organizational structure',
        component: WorkspaceHosts,
        required_permissions: [
            organizationPermissionCodes.organizationManageStructure,
        ],
        isOptional: true,
    },
    {
        key: WorkSpaceActions.MEMBER,
        label: 'members',
        component: WorkspaceMembers,
        required_permissions: [
            organizationPermissionCodes.organizationManageMember,
        ],
        isOptional: false,
    },
    {
        key: WorkSpaceActions.EXAMINATION,
        isServiceDisabled: (org) => !validateServiceType(
            _.get(org, 'service_type', '0000000000000000'),
            'examination'
        ),
        label: 'examination',
        component: WorkspaceExamination,
        isOptional: true,
    },
    {
        key: WorkSpaceActions.COURSE,
        label: 'course',
        component: WorkspaceCourse,
        isOptional: false,
    },
    {
        key: WorkSpaceActions.SHOP,
        isServiceDisabled: (org) => !validateServiceType(
            _.get(org, 'service_type', '0000000000000000'),
            'product'
        ),
        label: 'shops',
        component: WorkspaceShop,
        isOptional: true,
    },
    {
        key: WorkSpaceActions.HOUSEHOLD,
        label: 'households',
        component: WorkspaceCatholicHousehold,
        isOptional: true,
    },
    {
        key: WorkSpaceActions.OPERATING,
        label: 'operating',
        component: WorkspaceOperating,
        isOptional: false,
    },
    {
        key: WorkSpaceActions.SETTING,
        label: 'setting',
        component: WorkspaceSetting,
        isOptional: false,
    },
].filter(e => !!!e?.isInvisible)
    .map(({key, required_permissions = [], component, ...route}) => ({
        key,
        ...route,
        required_permissions,
        component: required_permissions
            ? createCheckPermissions(required_permissions)(component)
            : component,
    }))

export const SectionTemplate = ({title, description, actionText, renderActionButton}) => (
    <div className="p-1 sm:p-2 w-full">
        <h1 className="text-xl font-bold text-primary uppercase mb-4">{title}</h1>
        <div className="p-4 background border border-color-50 shadow-lg rounded-xl">
            <p className="mb-2 text-base text-color-200 tracking-wider">
                {description}
            </p>
            {renderActionButton && (
                <div className="text-right">
                    {renderActionButton()}
                </div>
            )}
        </div>
    </div>
);


const Workspace = () => {
    const {organization} = useContext(WorkspaceContext)
    const isReady = _.has(organization, 'available_actions')
    const permissions = useContext(PermissionContext)

    return (
        <ModuleLayoutWrapper
            Header={NullAsDefault}
            visibleLeftDrawer={true}>
            <DefaultTemplate renderMenu={NullAsDefault}>
                <WorkspaceBanner/>
                {isReady ? (
                    <WorkspaceFeatures
                        routes={routes}
                        // isDisabled={({required_permissions}) => true}
                        isDisabled={({required_permissions}) =>
                            !hasPermissions(permissions, required_permissions)
                        }
                        defaultAction={WorkSpaceActions.HOME}
                    />
                ) : (
                    <LoadingBlock/>
                )}
            </DefaultTemplate>
        </ModuleLayoutWrapper>
    )
}

export default compose(
    connect((state) => {
        const login = getLogin(state)
        const primary_org = _.get(login, 'primary_org')
        return {
            primary_org,
            [permissionCodes.canEdit]: Boolean(
                !_.isEmpty(_.get(login, 'primary_org'))
            ),
        }
    }),
    branch(
        ({primary_org}) => _.isEmpty(primary_org),
        () => () => <WorkspaceLandingPage/>
    ),
    branch(
        (props) => !_.get(props, permissionCodes.canEdit),
        () => () => <Redirect to={staticPaths.start}/>
    )
)(nest(WorkspaceProvider, Workspace))
